import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import IBimagePelvicobliquity1 from '@/pages/ReportV2/components/Modals/assets/IBimagePelvicobliquity1.png';
import IBimagePelvicobliquity2 from '@/pages/ReportV2/components/Modals/assets/IBimagePelvicobliquity2.png';
// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { VerticalSwiper } from '@/components/swiper';
export const PelvicObliquityModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBimagePelvicobliquity1} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  At initial contact the position of it is almost neutral (0° obliquity). Throughout loading response,
                  the hip of the trailing leg begins to drop, increasing the magnitude of pelvic obliquity. Hip
                  abductors become active to halt the contralateral pelvic drop.
                  <br></br>
                  <br></br>
                  After midstance, the motion of the pelvis is reversed, with the swing-side hip lifting to regain
                  neutral position again. This movement is called ‘hike’. People with a normal healthy gait, typically
                  exhibit 5° to 7° of pelvic obliquity towards each side. The magnitude of pelvic obliquity increases
                  linearly with walking speed.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center' style={{ height: '100%' }}>
              <div>
                <IonRow class='ion-justify-content-center' style={{ height: '50%', width: '100%' }}>
                  <IonCol className='ion-no-padding' size='11'>
                    <div>
                      <IonImg class={styles.avatar} src={IBimagePelvicobliquity2} />
                    </div>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size='11'>
                    <div>
                      Since the weight of the upper body acts downward through the pelvis, control of pelvic motion is
                      vital to maintaining whole body balance in the coronal plane.
                      <br></br>
                      <br></br>
                      Excessive pelvic drop (Trendelenburg sign) is due to weakness of the hip abductors on the
                      supporting leg side.
                    </div>
                  </IonCol>
                </IonRow>
              </div>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
